export default __webpack_public_path__ + "static/media/06-do-your-homework.1b79f3c9.jpg";